(function(){
    'use strict';

a3_cabin_reports.controller('BucketDayCtrl', BucketDayCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name BucketDayCtrl
     * @description 
     *   Shows the Bucket Day informations
     * @ngInject
     */

     function BucketDayCtrl($scope, BucketFactory, $routeParams, $location, $uibModal, UserFactory, SettingsMain, $timeout) {
        $scope.isSharedLate = false;
        $scope.selectedStates = "Shared, Pending"; 

        
        /**
         * Checks if duty wont be approved in time because of the weekend  
         * @memberof BucketDayCtrl
         */
        function checkLateShare() {
            var today = new Date();
            var dutyDay = new Date($scope.duty.DutyBegin);

            // how many days until duty date
            var trimmedToday = new Date(today);
            var trimmedDutyDay = new Date(dutyDay);
            var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedDutyDay.trimTime());

            //friday saturday sunday
            var fss = [5, 6, 0];
            //saturday sunday monday
            var ssm = [6, 0, 1]

            // today is Fr,Sa,Su   AND   duty on Sa,Su,Mo   AND   same weekend
            if (fss.contains(today.getDay()) && ssm.contains(dutyDay.getDay()) && diffDays < 4){
                //friday before 14:00 is not a late share
                if (!(today.getDay() == 5 && today.getUTCHours() < 14))
                    $scope.isSharedLate = true;
            }
        }

        $scope.currentDutyId = dutyId;
         
        $scope.initialized = false;
         
        $scope.displayMessage = displayMessage;
        $scope.confirmUnshare = confirmUnshare;
        $scope.shareDuty = shareDuty;
        $scope.isLoading = false;

        var dutyId = $routeParams.dutyId;
        $scope.currentDutyId = dutyId;
       
        
        
        var user = UserFactory.getUser();
        $scope.activeTab = 0;
                  
        
        $scope.duty = null;
        $scope.Duties = [];
        $scope.proposals =  [];
  
        $scope.toggle = {
            Accepted:true,
            Rejected:false,
            Pending:true,
            Bookmarks:true
        }
         
        $scope.getProposalBorderStyle = getProposalBorderStyle;
        
           function getProposalBorderStyle(proposal){
            var textclass="";
            if(proposal.Status == "Pending"  && proposal.State == 'Out' ){
                textclass="border-left-light-blue";
            }else if(proposal.Status == "Rejected" || proposal.Status ==  "RejectedBySTP"){
                  textclass="border-left-red";
            }else if(proposal.Status == "Pending"  && proposal.State == 'In'){
                  textclass="border-left-orange";
            }else if(proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP" ){
                textclass="border-left-green";
            } else if(  proposal.Status == "Shared"){
                textclass="border-left-blue-gray";
            }
             return textclass;
         } 
         
         
        $scope.logged_user_info = user.aimsId + ' - ' + user.name;

        
        $scope.hasTimeChange = false;
        
        $scope.approvedDuty = null;
        $scope.showMobileProposalCriteria = false;
        
        $scope.filterProposal = filterProposal;
        $scope.hasProposals = hasProposals;
        
        function hasProposals(){
            var value = false;
            if($scope.duty && $scope.duty.Duties){
                for(var i=0;i<$scope.duty.Duties.length;i++) {   
                    if($scope.duty.Duties[i].Id>0){
                            value = true;
                        break;
                    }
                }
                if(!value && $scope.activeTab != 1 ) {
                    $scope.activeTab = 1;
                }
            }
            return value;
        }
         
        function filterProposal(proposal){
            var isShown = false;
///ng-if="proposal.Id >0 && filterProposal(proposal)"
           if (proposal.Id>0){
                if(proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP" ){
                    $scope.approvedDuty = true;
                    if($scope.toggle.Accepted)
                        isShown = true;
                }else if(proposal.Status == "Pending" && $scope.toggle.Pending){
                    isShown = true;
                }else if((proposal.Status == "Rejected" || proposal.Status ==  "RejectedBySTP") && ($scope.toggle.Rejected || !proposal.isAcknowledged)){
                    isShown = true;
                }else if(proposal.Status == "Bookmarked" && $scope.toggle.Bookmarks){
                     isShown = true;
                }
           } 
            
            return isShown;
        }

        
        $scope.returnToBucket = returnToBucket;

        $scope.refresh = getData;
        
        getData();	
    
        function getData(){
            $scope.isLoading = true;
            BucketFactory.getDutyById(dutyId, function(responseData){ 
                $scope.initialized = true;
                $scope.isLoading = false;
                $scope.duty = responseData.data.data.duty;
                $scope.currentDutyDate = $scope.duty.DutyDateS;
                $scope.Duties = responseData.data.data.duty.Duties;
                $scope.totalItems = $scope.Duties.length;
                $scope.currentPage = 1;

                SettingsMain.setCalendarSelectedDate($scope.currentDutyDate);
                
                checkLateShare();
                initProposalsView();
                
            }).catch(function(error) {
                    $scope.isLoading = false;
                    console.error('Wrong AimsId', error.status, error.statusText);
                    returnToBucket();
            });
        }

        function initProposalsView(){
            $scope.approvedDuty = false; 
            for(var i=0;i<$scope.duty.Duties.length;i++) {   
                if($scope.duty.Duties[i].Status == "Approved" || $scope.duty.Duties[i].Status == "ApprovedBySTP"  ){         
                    $scope.approvedDuty = true; 
                }
            }
        } 

        /**
         * Opens a dialog with information on a duty, 
         * Depending on the duty type (in proposal, out proposal or shared by other in bucket) different options are displayed:
         * 1. In proposal
         *      - Approve (available when in proposal not reviewed, will set status to Approved)
         *      - Reject (available when in proposal not reviewed, will set status to Rejected)
         *      - Reset (available when in proposal has been reviewed, will set status to Pending)
         *      - Close (available always, just closes dialog, no action performed)
         * 2. Out proposal
         *      - Remove (available when out proposal not reviewed, will remove request from duty)
         *      - Close (available always, just closes dialog, no action performed)
         * 3. Shared in bucket
         *      - Request (available always, will send a request for duty, will be added in out proposals)
         *      - Close (available always, just closes dialog, no action performed)
         * @memberof BucketCtrl
         */

    
        /**
         * Prompts user to confirm sharing duty, if user agrees then the duty dialog will open  
         * @memberof BucketCtrl
         */
        function shareDuty(duty) {
            //if (confirm('You are about to share into global bucket the selected duty. Do you wish to continue?')) {
            duty.fromShareBtn = true;
            
                 var modalInstance = $uibModal.open({
                     templateUrl: 'views/Dialogs/dlgDuty.html',
                    controller: 'BucketModalCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        duty: function () { return duty; },
                        currentDutyId: function () { return dutyId; }
                        }
                    });
                    
                    modalInstance.result.then(function (refresh) {
                        if(refresh){
                            getData();
                        }
                    });
            //}
        }

        /**
         * Prompts user to confirm removing duty from shared bucket, if user agrees then all proposal for the duty will be removed (will be displayed as N/A to other users)  
         * @memberof BucketCtrl
         */

        function confirmUnshare() {
            bootbox.dialog({
                message: "<strong>Please confirm that you wish to Un-share your duty.</strong><br/><br/>",
                title: "Unshare",
                buttons: {
                     confirm:{
                        label: '<i class="fa fa-trash-o widget-icon text-white"></i> Confirm',
                        className: "btn-warning",
                        callback: function(){
                            BucketFactory.shareDuty($scope.duty, function(responseData){ 
                                $scope.responseText = responseData.data.data;
                                getData();
                            })
                        }
                    },  
                    cancel:{
                        label: "Cancel",
                        className: "btn-default",
                        callback: function(){}
                    }
                }
            })
        }         

        /**
         * Redirects to bucket' calendar
         * @memberof BucketCtrl
         */
        function returnToBucket() {
            SettingsMain.setEditingPage(null);
            $location.path("/bucket/");
        }
        /**
         * Redirects to flights' calendar
         * @memberof BucketCtrl
         */
        function gotoFlightsCalendar() {
            SettingsMain.setEditingPage(null);
            $location.path("/");
        }
   
   
         //Pagination
		$scope.pageOptions = [
				{ name: '5', value: '5' }, 
				{ name: '8', value: '8' }, 
				{ name: '15', value: '15' },
				{ name: '30', value: '30' },
				{ name: '50', value: '50' }
		];
         
		$scope.viewby = $scope.pageOptions[1].value;
		$scope.currentPage = 1;
		$scope.itemsPerPage = $scope.viewby;
		$scope.maxSize = 5; //Number of pager buttons to show
		$scope.setPage = setPage;
		$scope.setItemsPerPage = setItemsPerPage;


         /**
         * Set pagination page number
         * @memberof BucketDayCtrl
         * @param {number} pageNo list page number
         */
		function setPage(pageNo) {
			$scope.currentPage = pageNo;
		}
        /**
         * Set items per  page 
         * @memberof BucketDayCtrl
         * @param {number} num the Number of items to show per page
         */
		function setItemsPerPage(num) {
			$scope.itemsPerPage = num;
			$scope.currentPage = 1; //reset to first page
		}
         
        
       function displayMessage(message, hasErrors) {
            $scope.showResponse = true;
            $scope.responseText = message;
            $scope.responseHasErrors = hasErrors;
            $timeout(function () {if(!hasErrors){$scope.showResponse = false;}} , 1000);
        }
       
    

}
})();
